// General app onboarding steps (different from jobs onboarding)
export const ONBOARDING_STEPS = {
  NOT_STARTED: 0,
  INTRO: 1,
  CUSTOMIZE_FEED: 2,
  COMPLETED: 3,
}
